import { useState } from "react";
import dayjs from "dayjs";
import { getCalendarEvent } from "../repository/data.repository";
import CalendarEventDialog from "./CalendarEventDialog";
import { CalendarEventForm } from "./CalendarEventDialog.default";

/**
 * Deep-link preview of the calendar event behind another record (a training's backing event, a
 * scheduled counselling session): `openPreview(eventUid)` fetches the event, maps it onto the
 * dialog's form shape and opens it read-only. Mount `previewDialog` once in the page.
 */
export function useCalendarEventPreview() {
  const [item, setItem] = useState<CalendarEventForm | null>(null);
  const [open, setOpen] = useState(false);

  function openPreview(eventUid: string): void {
    getCalendarEvent(eventUid).then((event) => {
      if (!event) return;
      setItem({
        title: event.title,
        description: event.description,
        startDateTime: dayjs(event.startDateTime),
        endDateTime: dayjs(event.endDateTime),
        company: { display: event.companyName, value: event.companyUid },
        departments: (event.departments ?? []).map((d) => ({
          display: d.departmentName,
          value: d.departmentUid,
        })),
        type: { display: event.typeName, value: event.typeUid },
        collaborator: {
          display: event.hosts?.[0]?.userUserName ?? "",
          value: event.hosts?.[0]?.userUid ?? "",
        },
        originType: event.originType,
        originUid: event.originUid,
      } as CalendarEventForm);
      setOpen(true);
    });
  }

  const previewDialog = (
    <CalendarEventDialog
      open={open}
      mode="preview"
      initialValues={item}
      onCancel={() => setOpen(false)}
    />
  );

  return { openPreview, previewDialog };
}
